// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__OwlUd","header":"PatientQuestionnaire_header__30i7M","info":"PatientQuestionnaire_info__3OzQV"};